import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import TableTitle from '../Table_Components/TableTitle/TableTitle';
import ListLoad from '../ListLoad/ListLoad';
import ComponentHolder from '../Common/ComponentHolder';
import PullToRefresh from '../PullToRefresh/index';
import * as helper from '../util/helper';
import * as urlHelper from '../util/url';
import * as uiHelper from '../util/ui';
import MemoryManager from '../util/memoryManager';
import debounce from 'lodash/debounce';
import AccLoading from '../DetailPage/AccLoading/AccLoading';
import TableList from '../Table_Components/TableList/TableList';
import EmptyIcon from '../EmptyIcon/EmptyIcon';
import * as html from '../util/html';
import * as linkURL from '../util/linkUrlJsonString';
import ButtonChoose from './ButtonChoose';
import transLoader from '@beisen/i18n-translation-loader';
require('./DataTable.scss');
let buttonListHeight = 0; //55px 此数值已过时 应用ref取 iPhone X手机高度和正常手机不一样
const headerHeight = 44; //44px
const defaultTranslation = {
    alreadyTop: '已经是第一页',
    loading: '加载中...',
    noMore: '没有更多了',
    viewMore: '查看更多',
    cancel: '取消',
    listEmpty: '暂时没有信息哦～'
};
export default class DataTable extends React.Component {
    static defaultProps = {
        cmp_id: '',
        cmp_data: null,
        hasBottomButton: () => {}
    }
    constructor(props,context) {
        super(props,context);
        this.checkEmptyBizData = this.checkEmptyBizData.bind(this);
        this.reloadTable = this.reloadTable.bind(this);
        this.tableItemClick = this.tableItemClick.bind(this);
        this.touchTapMore = this.touchTapMore.bind(this);
        this.onRowTouchTap = this.onRowTouchTap.bind(this);
        this.rowButtonListClear = this.rowButtonListClear.bind(this);
        this.rowButtonTouchTap = this.rowButtonTouchTap.bind(this);
        this.rowButtonItemTouchHandler = this.rowButtonItemTouchHandler.bind(this);
        this.showMoreList = this.showMoreList.bind(this);
        this.handleToTop = this.handleToTop.bind(this);
        this.setClickPos = this.setClickPos.bind(this);

        this.loadedPageRange = {
            min: 0, //当前已加载的最小的页数
            max: 0, //当前已加载的最大的页数
            capacity: props.cmp_data && props.cmp_data.paging.capacity, //每页的条数
            currentPageNum: Number.MAX_SAFE_INTEGER, //最近一次加载的是第几页
            first: 0 //DataTable第一次加载数据加载的是第几条
        };
        this.sortData = this.props.cmp_data && this.props.cmp_data.sort_fields || [];
        this.searchData = this.props.searchData;
        this.isTableFetching = false;
        this.isTableMounted = false;
        this.state = {
            isLoadingPrev: false,
            isLoaderMore: false,
            isShowChoose: false,
            showMoreIcon: 'm-sys-pull-refresh',
            showMoreLoad: false,
            emptyHeight: 0
        };
        if(!this.props.disableRemberPosition) {
            MemoryManager.setItemBeforeUnload(location.href,() => {
                return this.getCurrentVisbileItem();
            },'local');
        }
        this.rememberPostion = this.getRememberPosition();
        this.display = 'none';
        this.windowHeight = window.innerHeight;
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            alreadyTop: 'table.alreadyTop',
            loading: 'common.loading',
            noMore: 'table.noMore',
            viewMore: 'table.viewMore',
            cancel: 'common.cancel',
            listEmpty: 'common.listEmpty'
          }), props.translation);
    }

    componentDidMount() {
        this.isTableMounted = true;
        buttonListHeight = buttonListHeight || this.props.getFooterHeight && this.props.getFooterHeight();
        if(this.needLoadTableDataAfterMount()) {
              if(this.rememberPostion) {
                  this.recoverSearchSortData();
                  this.fetchTableViewData(this.rememberPostion.page,this.searchData,this.sortData,null,this.checkEmptyBizData);
                  if(this.props.updateSearchCondition) {
                      let conditions = {};
                      this.searchData && this.searchData.items && this.searchData.items.forEach(item  => {
                          conditions[item.name] = item;
                      });
                      this.props.updateSearchCondition(conditions);
                  }
                  return null;
              }
            this.fetchTableViewData(0, this.searchData,this.sortData, null);
        }
        this.registerScrollEvent();
        this.registerTouchStartEvent();
        this.registerTouchMoveEvent();
        this.setEmptyHeight();
    }
    componentWillReceiveProps(nextProps) {
        //处理后退是相同url的场景
        //this.rememberPostion = JSON.parse(MemoryManager.getItem(location.href));
        if(nextProps.searchData !== this.props.searchData) {
            this.searchData = nextProps.searchData;
        }
        if(nextProps.cmp_data && this.props.cmp_data && nextProps.cmp_data.paging.page != this.props.cmp_data.paging.page) {
            this.updateLoadedPageRange(nextProps);
        }
        this.loadedPageRange.currentPageNum = nextProps.cmp_data ? nextProps.cmp_data.paging.page : 0;
        if(!nextProps.isRetry && this.props.isRetry) {
             this.pageIsRetry = false;
        }
    }

    componentDidUpdate() {
        if(this.props.cmp_data && this.props.cmp_data.paging && this.props.cmp_data.paging.total == 0) {
            if(!this.props.expandRegion && !this.setedHeight) {
                this.setedHeight = true;
                this.setEmptyHeight();
            }
            this.props.displayTopAndBottom && this.props.displayTopAndBottom();
        }
        if(this.rememberPostion && this.loadedPageRange.currentPageNum == this.rememberPostion.page && this.refs.datatable) {
            this.scrollToPostion(this.rememberPostion.page,this.rememberPostion.row,this.rememberPostion.offsetTop);
            this.clearMemory();
        }
        if(this.pageHasRecordPosition && !this.pageIsRetry) {
            this.scrollToPostion(null, null, 'end');
            this.pageHasRecordPosition = null;
        }
        buttonListHeight = buttonListHeight || this.props.getFooterHeight && this.props.getFooterHeight();
        const datatabelList = this.refs.DataTableList;
        let node = datatabelList && datatabelList.getElementsByClassName('show-no-more');
        if(node && node.length > 0) {
            this.shouldShowNoMore = this.canShowNoMore();
            if(!this.shouldShowNoMore) {
                node[0].style.display = 'none';
            }else {
                node[0].style.display = 'block';
            }
        }

        if(!this.registedScrollEvent) {
            this.registerScrollEvent();
        }
        if(!this.registedTouchStartEvent) {
            this.registerTouchStartEvent();
        }
        if(!this.registedTouchMoveEvent) {
            this.registerTouchMoveEvent();
        }
    }

    componentWillUnmount() {
        const scrollParent = this.getScrollParent();
        if(scrollParent) {
            scrollParent.removeEventListener('scroll',() => {
                this.scrollHandler();
            },false);
            scrollParent.removeEventListener('touchstart',() => {
                this.touchStartHandler();
            },false);
            scrollParent.removeEventListener('touchmove',() => {
                this.touchMoveHandler();
            },false);
        }
    }

    getRememberPosition() {
        return JSON.parse(MemoryManager.getItem(location.href));
    }

    registerScrollEvent() {
        const scrollParent = this.getScrollParent();
        if(scrollParent && scrollParent != window) {
            scrollParent.addEventListener('scroll',debounce(this.scrollHandler.bind(this),300),false);
            this.registedScrollEvent = true;
        }
    }

    registerTouchStartEvent() {
        const scrollParent = this.getScrollParent();
        if(scrollParent && scrollParent != window) {
            scrollParent.addEventListener('touchstart',e => {
                this.touchStartHandler(e);
            },false);
            this.registedTouchStartEvent = true;
        }
    }

    registerTouchMoveEvent() {
        const scrollParent = this.getScrollParent();
        if(scrollParent && scrollParent != window) {
            scrollParent.addEventListener('touchmove',e => {
                this.touchMoveHandler(e);
            },false);
            this.registedTouchMoveEvent = true;
        }
    }

    fetchTableViewData(pageIndex, searchData, sortData, loadType = null, afterAction) {
        const { isIndexPop,popParams } = this.props;
        const context = isIndexPop ? Object.assign({} ,popParams,{ 'viewName': this.props.cmp_data.viewName }) : {
            'viewName': this.props.cmp_data.viewName,
            'metaObjName': this.props.cmp_data.metaObjName
        };
        this.props.actions.fetchTableViewData(this.props.cmp_id, context, this.genFetchParams(pageIndex, searchData, sortData), loadType, afterAction);
    }

    genFetchParams(pageIndex = 0, searchData = null, sortData = null) {
        let tableData = Object.assign({}, this.props.cmp_data, { paging: Object.assign({},this.props.cmp_data.paging, { page: pageIndex }) });
        if(sortData) {
            tableData = Object.assign({},tableData,{ sort_fields: sortData });
        }else {
            tableData = Object.assign({},tableData,{ sort_fields: [] });
        }
        let postBody = {
              'table_data': tableData
        };
        if(this.props.postPageContext) {
            postBody.page_context = {
                 'metaObjName': this.props.cmp_data.metaObjName
                ,'viewName': this.props.queryUrl.detailViewName
                ,'DataId': this.props.queryUrl.pObjectDataID
            };
        }
        if(this.props.tableAjaxParam) {
            postBody = Object.assign(postBody,this.props.tableAjaxParam);
        }
        if(searchData) {
             postBody.search_data = searchData;
        }
        // 区分相关对象
        if(this.props.moduleID) {
            postBody.moduleID = this.props.moduleID;
        }
        return postBody;
    }

    checkEmptyBizData(response) {
        const tableData = response.data;
        if(tableData && tableData.cmp_data && tableData.cmp_data.paging.page > 0) {
            if(!tableData.biz_data || tableData.biz_data.length === 0) {
                this.pageIsRetry = true;
                this.pageHasRecordPosition = true;
                this.fetchTableViewData(tableData.cmp_data.paging.page - 1 ,this.searchData,this.sortData,'isRetry');
            }
        }
    }

    canShowNoMore() {
        const dataTableContainer = this.refs.dataTableContainer && ReactDOM.findDOMNode(this.refs.dataTableContainer);
        const dataTable = this.refs.datatable;
        if(dataTableContainer && dataTable) {
            const maxPage = Math.ceil(this.props.cmp_data.paging.total / this.props.cmp_data.paging.capacity);
            const bottomHeight = this.props.hasBottomButton() ? buttonListHeight : 0;
            if((dataTableContainer.clientHeight >= (dataTable.clientHeight + bottomHeight)) && (maxPage <= 1) || this.props.cmp_data.paging.total == 0) {
                return false;
            }
        }
        return true;
    }

    recoverSearchSortData() {
         this.searchData = this.rememberPostion.searchData;
         this.sortData = this.rememberPostion.sortData;
         this.loadedPageRange.min = this.rememberPostion.page;
         this.loadedPageRange.first = this.rememberPostion.page;
    }

    needLoadTableDataAfterMount() {
        return this.props.loadData == false && !this.props.isFetching;
    }

    isRowInViewPort(row,tableItems,scorllParent) {
        let height = 0, scrollParentHeight = scorllParent.offsetHeight;
        for(let i = 1; i < row; i++) {
             height = height + tableItems[i - 1].offsetHeight;
        }
        return height <= scrollParentHeight;
    }

    scrollToPostion(page,row, offsetTop) {
        let scorllParent = this.getScrollParent();
        if(offsetTop === 'end') {
            scorllParent.scrollTop = scorllParent.scrollHeight;
            return null;
        }
        const dataTable = ReactDOM.findDOMNode(this.refs.datatable);
        // this.props.cmp_data.rowTemplate ? 'tableTpl-item' :
        const tableItems = dataTable.getElementsByClassName('table-list-item');
        if(tableItems.length < row) {
            return null;
        }
        if(page != 0 && offsetTop > 0 && this.isRowInViewPort(row, tableItems,scorllParent)) {
            return null;
        }else {
            tableItems[row - 1].scrollIntoView();
            const scrollTop = scorllParent.scrollTop;
            if(dataTable.offsetHeight > (scorllParent.offsetHeight + scrollTop)) {
                scorllParent.scrollTop = scrollTop - offsetTop;
            }
        }
    }

    clearMemory() {
        this.rememberPostion = null;
        MemoryManager.removeItem(location.href);
        if(this.props.clearMemoryAfterMount) {
            this.props.clearMemoryAfterMount();
        }
    }

    getScrollParent() {
        if(this._scrollParent && this._scrollParent != window) {
            return this._scrollParent;
        }
        this._scrollParent = uiHelper.getScrollParent(ReactDOM.findDOMNode(this.refs.datatable));
        return this._scrollParent;
    }

    getScrollTop() {
        return uiHelper.getScrollTop(this.getScrollParent());
    }

    getScrollParentHeight() {
         return Number.parseFloat(window.getComputedStyle(this.getScrollParent()).height.replace('px',''));
    }

    getOffsetTop(ele) {
        //return Math.abs(ele.getBoundingClientRect().top - 44); //+ ele.offsetHeight - 44;
        return ele.getBoundingClientRect().top - 44;
    }

    getCurrentVisbileItem() {
         if(this.clickedPosition) {
             return this.clickedPosition;
         }
         const scrollTop = this.getScrollTop();
         //const parentHeight = this.getScrollParentHeight();
         const dataTable = ReactDOM.findDOMNode(this.refs.datatable);
         let tableItems = dataTable && dataTable.getElementsByClassName('table-list-item');
         if(!tableItems || tableItems.length === 0) {
             return null;
         }
         let height = 0;
         for(let i = 1; i <= tableItems.length; i++) {
             height = height + tableItems[i - 1].offsetHeight;
             if(height >= scrollTop) {
                 return this.calcTableItemPosition(i,tableItems[i - 1]);
             }
         }
    }

    calcTableItemPosition(row, tableItem) {
        if(!tableItem && row > 0) {
            let tableItems = ReactDOM.findDOMNode(this.refs.datatable).getElementsByClassName('table-list-item');
            if(!tableItems || tableItems.length === 0) {
                 return null;
            }
            tableItem = tableItems[row - 1];
        }
        if(row > 0 && tableItem) {
            const capacity = this.loadedPageRange.capacity;
            const offsetTop = this.getOffsetTop(tableItem);
            const position = { page: (Math.ceil(row / capacity) > 0 ? Math.ceil(row / capacity) - 1 : 0) + this.loadedPageRange.min , row: (row % capacity === 0 && row >= capacity) ? capacity :  row % capacity , offsetTop: offsetTop,searchData: this.searchData,sortData: this.sortData };
            if(this.props.rememberBeforeJump) {
                this.props.rememberBeforeJump();
            }
            return position;
        }
        return null;
    }

    updateLoadedPageRange(props) {
        const currentPageNum = props.cmp_data.paging.page;
        if(currentPageNum != this.loadedPageRange.min && currentPageNum != this.loadedPageRange.max) {
            this.isTableFetching = false;
        }
        if(currentPageNum < this.loadedPageRange.min) {
            this.loadedPageRange.min = currentPageNum;
        }
        if(currentPageNum > this.loadedPageRange.max) {
            this.loadedPageRange.max = currentPageNum;
        }
        this.loadedPageRange.currentPageNum = currentPageNum;
        this.loadedPageRange.capacity = props.cmp_data.paging.capacity;
    }

    isScrollToEnd() {
        const showMoreArea = ReactDOM.findDOMNode(this.refs.showMoreArea);
        if(!showMoreArea) {
            return null;
        }
        // let otherHeight = this.props.hasBottomButton ? buttonListHeight : 0;
        // 下滑到最底部时 肯定是隐藏了底部按钮的
        if(showMoreArea.getBoundingClientRect().top <= window.innerHeight) {
            return true;
        }
        return false;
    }

    handleToTop() {
        this._scrollParent.scrollTop = 0;
        if(window.env.platform.bsAppIOS) {
            // 解决apicloud中table更新数据后  滚动条不置顶的问题
            const elementForTrans = this.refs.elementForTrans;
            elementForTrans.style.transform = 'translateY(0px)';
            elementForTrans.style.WebkitTransform = 'translateY(0px)';

            setTimeout(() => {
                elementForTrans.style.transform = 'translateY(1px)';
                elementForTrans.style.WebkitTransform = 'translateY(1px)';
            });
        }
    }

    scrollHandler() {
        let scorllParent = this.getScrollParent();
        if(this.props.displayToTop && this.props.hideToTop) {
            if(scorllParent.scrollTop > 2 * this.windowHeight) {
                if(this.display == 'none') {
                    this.props.displayToTop && this.props.displayToTop();
                    this.display = 'block';
                }
            }else {
                if(this.display == 'block') {
                    this.props.hideToTop && this.props.hideToTop();
                    this.display = 'none';
                }
            }
        }
        if (!this.isTableFetching && this.isScrollToEnd()) {
            this.isTableFetching = true;
            if (this.props.loadMore) {
                this.props.loadMore();
            } else {
                this.fetchTableViewData(this.loadedPageRange.max + 1, this.searchData, this.sortData, 'isLoadMore');
            }
        }
    }

    touchStartHandler(e) {
        this.touchStartY = e.pageY || e.changedTouches[0].pageY;
    }

    touchMoveHandler(e) {
        const touchMoveY = e.pageY || e.changedTouches[0].pageY;
        this.moveY = touchMoveY - this.touchStartY;
            if(this.moveY < 0 && this.canShowNoMore()) {
                // 上滑
                this.props.hideTopAndBottom && this.props.hideTopAndBottom();
            }else if(this.moveY > 0 && this.canShowNoMore()) {
                // 下拉 tab button 出现
                this.props.displayTopAndBottom && this.props.displayTopAndBottom();
            }
    }

    loadPrevPage(e) {
        const { translation } = this;
        this.props.displayTopAndBottom && this.props.displayTopAndBottom();
        if(this.loadedPageRange.min > 0) {
            this.fetchTableViewData(this.loadedPageRange.min - 1, this.searchData, this.sortData, 'isLoadPrev');
            this.rememberPostion = { page: this.loadedPageRange.min - 1 , row: this.loadedPageRange.capacity + 1, offsetTop: 0 };
        }else if(!this.isfakeLoading) {
            this.isfakeLoading = true;
            this.setState({ fakeLoading: true },() => {
                setTimeout(() => {
                    this.props.actions.showTip({ message: translation.alreadyTop, type: 'success' });
                    this.setState({ fakeLoading: false });
                    this.isfakeLoading = false;
                },500);
            });
        }
    }

    resetPageRange() {
        this.loadedPageRange.min = 0;
        this.loadedPageRange.max = 0;
        this.loadedPageRange.currentPageNum = 0;
        this.loadedPageRange.first = 0;
    }

    reloadTable(data) {
        let page = 0;
        if (!this.rememberPostion && !this.getRememberPosition()) {
            this.resetPageRange();
            if (data && data.searchData) {
                this.searchData = data.searchData;
            } else {
                this.searchData = this.props.searchData;
            }
            if (data && data.sortData) {
                this.sortData = data.sortData;
            }
        } else {
            if(!this.rememberPostion) {
                this.rememberPostion = this.getRememberPosition();
            }
            this.recoverSearchSortData();
            page = this.rememberPostion.page;
            this.fetchTableViewData(this.rememberPostion.page,this.searchData,this.sortData,null,this.checkEmptyBizData);
            if(this.props.updateSearchCondition) {
                let conditions = {};
                this.searchData && this.searchData.items && this.searchData.items.forEach(item  => {
                    conditions[item.name] = item;
                });
                this.props.updateSearchCondition(conditions);
            }
            return null;
        }
        this.fetchTableViewData(page, this.searchData, this.sortData);
    }

    genCmpContext() {
        return Object.assign({},this.props.cmpContext,{
            metaObjName: this.props.cmp_data.metaObjName,//this.props.queryUrl.metaObjName,
            viewName: this.props.indexContext && this.props.indexContext.viewName || this.props.cmp_data.viewName
        });
    }

    setClickPos(index) {
        this.clickedPosition = this.calcTableItemPosition(index + 1);
    }

    tableItemClick(e, item, index) {
        if(this.props.onTableItemClick) {
            this.props.onTableItemClick(e, item);
            return null;
        }
        this.setClickPos(index);
        //this.clickedPosition = this.calcTableItemPosition(index + 1);
        let dataItem = Object.assign({},item);//此处需要将型参item转换一下再去修改，因为item read only
        for(let key in dataItem) {
            if(typeof dataItem[key] === 'object' && dataItem[key] != null) {
                dataItem[key] = dataItem[key]['value'];
            }
        }
        let pageModule = null;
        if(this.props.queryUrl && this.props.queryUrl.pageModule) {
            pageModule = this.props.queryUrl.pageModule;
        }
        let redirectUrl = '';
        if(window.beisenUtils && window.beisenUtils.getTableJumpUrl) {
            const linkItem = this.props.sub_cmps.find(function(item) {
                return item.cmp_data.isLink && item.cmp_data.linkURL;
            }) || null;
            redirectUrl = window.beisenUtils.getTableJumpUrl(dataItem,this.props.queryUrl,this.genCmpContext(), linkItem);
        }
        const linkUrlString = dataItem.linkUrl && linkURL.linkUrlJsonString(dataItem.linkUrl);
        redirectUrl = redirectUrl || urlHelper.formatUrl((linkUrlString && linkUrlString.url) || linkUrlString,this.props.queryUrl,this.genCmpContext(),[dataItem]);
        if(redirectUrl) {
            if(redirectUrl.indexOf('?') > -1) {
                redirectUrl = redirectUrl + '&fromURL=homedetail';
            }else{
                redirectUrl = redirectUrl + '?fromURL=homedetail';
            }
            redirectUrl  +=  (pageModule ? '&pageModule=' + pageModule : '');
            let urlover = urlHelper.androidChangeTime_stampToSearch(redirectUrl);
            //如果为Basepage的相关列表跳转详情页，需要添加参数
            if (this.props.queryUrl.viewpath == 'pageModule') {
                //用于标示当前是相关列表页
                urlover = `${urlover}&BasePageModule=BasePageModule`;
                // const queryObject = helper.getQueryObject();
                // redirectUrl = `#/BasePage?metaKey=${metaKey}&fromURL=homedetail&pObjectDataID=${this.props.detailPage.cmp_data.dataID}&viewName=${relateViewObj.cmp_data.viewName}&metaObjName=${this.props.detailPage.cmp_data.metaObjectName}&showMenu=${this.props.showMenu}&showBack=${this.props.showBack}&viewpath=pageModule&detailViewName=${queryObject && queryObject.detailViewName ? queryObject.detailViewName : this.props.detailPage.cmp_data.viewName}&currentDetailPageViewName=${relateViewObj.cmp_data.currentDetailPageViewName}&mainDetailViewName=${this.props.detailPage.cmp_data.viewName}`;
            //如果这个页面是详情页里的列表
            } else if (this.props.basePageModule) {
                urlover = `${urlover}&detaileBasePageModule=${this.props.basePageModule}`;
            }
            helper.pageJump(urlover, { openModel: dataItem.OpenTarget || '', 'hasShadowContext': typeof linkUrlString.hasShadowContext !== 'undefined' ? linkUrlString.hasShadowContext : true });
        }
    }

    //根据TableList元数据生成基础组件需要的数据
    genBasicComponentNeededDataList() {
        let showColumn = this.props.showColumn;
        const rowsLimit = this.props.rowsLimit;
        let datalist = [];
        if(this.props.biz_data.length == 0 && this.props.cmp_data.paging.page == 0) {
            datalist = [];
        }else{
            let cloneData = Object.assign(this.props.biz_data);
            if(rowsLimit) {
                if(this.props.biz_data.length > rowsLimit) {
                    cloneData = this.props.biz_data.slice(0,rowsLimit);
                }
            }
            datalist = [];

            cloneData.forEach((row,rowIndex) => {
                let item = {
                    showChecked: this.props.showChecked || false,
                    mainInfo: {},
                    subInfo: []
                };
                (this.props.selectIds && this.props.selectIds.indexOf(row['_id'].value) >= 0) ? item.checked = true : item.checked = false;
                let colIndex = 0;

                // 移动端跳转到详情页是取第一个配置了hasLink并且有linkUrl的列数据，所以用两个变量来存储取到的列数据
                let hasSignUrl = '';
                let rowItemHasSgin = false;
                this.props.sub_cmps.forEach((col,index) => {
                    let cellItem = row[col.cmp_data.name];
                    item[col.cmp_data.name] = cellItem;
                    if(this.props.cmp_type == 'Form') {
                        cellItem = row[col.cmp_data.field_name];
                        item[col.cmp_data.field_name] = cellItem;
                    }
                    if(!cellItem) {
                        cellItem = {};
                    }
                    let avatar = cellItem.avatars && cellItem.avatars[cellItem.value];
                    if(['SingleStaffInput','MultiStaffInput'].indexOf(col.cmp_data.controlPack) != -1) {
                        cellItem.text = uiHelper.extractUserName(cellItem.text);
                    }

                    // 默认详情页连接地址
                    if(col.cmp_data.isLink && !item.linkUrl) {
                        item.linkUrl = col.cmp_data.linkURL || helper.getAPI('TableColLinkTemp');// 获取table跳转详情页的默认连接地址

                        item.OpenTarget = col.cmp_data.OpenMode;
                    }

                    // 审批详情页连接地址
                    if(col.cmp_data.isLink && col.cmp_data.linkType === 'approvalCenterDetailPage') {
                        let colBizData = cloneData[rowIndex];
                        let dataItem = Object.assign({},colBizData);
                        for(let key in dataItem) {
                            if(typeof dataItem[key] === 'object' && dataItem[key] != null) {
                                dataItem[key] = dataItem[key]['value'];
                            }
                        }
                        // 2018/03/14 修改审批详情页链接替换规则
                        // 原型地址 http://10.129.8.22:97/v2.27 开发态、实施态列表中字段审批详情页链接地址防篡改
                        if(colBizData.ApprovalObjectDataId && colBizData.WorkFlowProcessId) {
                            item.linkUrl = urlHelper.formatUrl(item.linkUrl,this.props.queryUrl,this.genCmpContext(),[dataItem]);
                        }else {
                            const approvalUrl = urlHelper.formatUrl(item.linkUrl,this.props.queryUrl,this.genCmpContext(),[dataItem]);
                            let approvalUrlQueryObj = helper.parseUrlParams(approvalUrl);
                            if (approvalUrlQueryObj.approvalObjectId && approvalUrlQueryObj.processInstanceId) {
                                item.linkUrl = approvalUrl;
                            }else {
                                item.linkUrl = helper.getAPI('TableColLinkTemp');
                            }
                        }

                    }

                    if(col.cmp_data.signFormat && !rowItemHasSgin) {
                      hasSignUrl = item.linkUrl.endsWith('&') ? item.linkUrl.concat(col.cmp_data.signFormat) : item.linkUrl.concat('&' + col.cmp_data.signFormat);
                      rowItemHasSgin = true;
                    }

                    if(col.cmp_data.controlPack != 'RTF') {
                        if(col.cmp_data.visible || col.cmp_data.visible == undefined) {
                            if(col.cmp_data.frozen && colIndex == 0) {
                                if(col.cmp_data.controlPack === 'MultiplePicUpload' || col.cmp_data.controlPack === 'PicUpload' || col.cmp_data.controlPack === 'FileUpload') {
                                    item.mainInfo.mainDownloadUrl = cellItem.downloadUrl;
                                    item.mainInfo.mainClientUrl = cellItem.clientUrl;
                                    item.mainInfo.mainType = col.cmp_data.controlPack.indexOf('PicUpload') >= 0 ? 'pic' : 'file';
                                };
                                item.mainInfo.title = uiHelper.extractUserName(cellItem.text);
                                if(col.cmp_data.controlPack == 'SingleStaffInput') {
                                    item.mainInfo.Name = uiHelper.extractUserName(cellItem.text) || '----';
                                    item.mainInfo.showMedia = true;
                                    if(avatar) {
                                        item.mainInfo.avatars = avatar;
                                    }else{
                                        item.mainInfo.mediaType = 'default';
                                    }
                                }
                            }else if(col.cmp_data.frozen && colIndex == 1) {
                                if(col.cmp_data.controlPack === 'MultiplePicUpload' || col.cmp_data.controlPack === 'PicUpload' || col.cmp_data.controlPack === 'FileUpload') {
                                    item.mainInfo.subDownloadUrl = cellItem.downloadUrl;
                                    item.mainInfo.subClientUrl = cellItem.clientUrl;
                                    item.mainInfo.subType = col.cmp_data.controlPack.indexOf('PicUpload') >= 0 ? 'pic' : 'file';
                                };
                                item.mainInfo.subTitle = cellItem.text;
                            }else{
                                let subItem = {
                                    'title': col.cmp_data.title
                                };
                                subItem.ControlType = col.cmp_data.controlPack;
                                subItem.value = cellItem.value;
                                if(avatar) {
                                    subItem.type = 'user';
                                    subItem.avatars = avatar;
                                    subItem.Id = cellItem.value;
                                    subItem.Name = uiHelper.extractUserName(cellItem.text);
                                }
                                if(col.cmp_type === 'MultiplePicUpload' || col.cmp_type === 'PicUpload' || col.cmp_type === 'FileUpload') {
                                    subItem.downloadUrl = cellItem.downloadUrl;
                                    subItem.clientUrl = cellItem.clientUrl;
                                }
                                subItem.content = html.decode(cellItem.text || '');
                                if(showColumn == undefined || (showColumn && showColumn - 1 >= colIndex)) {
                                    item.subInfo.push(subItem);
                                }
                            }
                            colIndex = colIndex + 1;
                        }
                    }
                });
                if(item.mainInfo.title === undefined) {
                    let firstSub = item.subInfo.shift();
                    item.mainInfo.title = firstSub && firstSub.content;
                    if(firstSub && (firstSub.ControlType == 'MultiplePicUpload' || firstSub.ControlType == 'PicUpload')) {
                        item.mainInfo.mainContent = firstSub.content;
                        item.mainInfo.mainDownloadUrl = firstSub.downloadUrl;
                    }
                    if (firstSub && firstSub.ControlType == 'SingleStaffInput') {
                        item.mainInfo.Name = uiHelper.extractUserName(firstSub.content) || '----';
                        item.mainInfo.showMedia = true;
                        if(firstSub.avatars) {
                            item.mainInfo.avatars = firstSub.avatars;
                        }else{
                            item.mainInfo.mediaType = 'default';
                        }
                    }
                }

                if(hasSignUrl) {
                  item.linkUrl = hasSignUrl;
                }
                datalist.push(Object.assign(row,item));
            });
        }

        return datalist;
    }

    touchTapMore() {
        if(this.props.onTouchMore) {
            this.props.onTouchMore();
            return null;
        }
        let redirectUrl = '#/indexPage?metaObjName=' + this.props.cmp_data.metaObjName + '&fromURL=homedetail';
        helper.pageJump(redirectUrl);
    }

    checkTableHasRecord() {
        return this.props.cmp_data && this.props.cmp_data.paging && (this.props.cmp_data.paging.total > 0 || this.props.biz_data && this.props.biz_data.length > 0);
    }

    onRowTouchTap(id,index) {
        this.index = index;
        this.title = '';
        this.setState({ isShowChoose: true },() => {
            let params = {};
            params.cmp_id = this.props.cmp_id;
            params.id = id;
            params.viewName = this.props.cmp_data.viewName;
            params.metaObjName = this.props.cmp_data.metaObjName;
            params.cmpContext = this.genCmpContext();
            params.queryUrl = this.props.queryUrl;
            let biz_data = this.props.biz_data.filter(biz => {
                return biz._id.value === id;
            });
            params.data = Object.assign({},{ cmp_data: this.props.cmp_data },{ cmp_id: this.props.cmp_id },{ cmp_name: this.props.cmp_name },{ cmp_type: this.props.cmp_type },{ sub_cmps: this.props.sub_cmps },{ biz_data: biz_data });
            this.props.actions.rowButtonListfn(params);
        });
    }

    rowButtonItemTouchHandler(btnItem, index) {
        this.index = index;
        this.title = '';
        if(btnItem) {
            this.rowButtonTouchTap(btnItem);
        }else{
            this.setState({ isShowChoose: true });
        }
    }

    rowButtonTouchTap(btnItem) {

        let {
            cmpContext,
            queryUrl,
            pageType
        } = this.props;
        let afterAction = this.reloadTable;
        let data = [].concat(this.props.biz_data[this.index]);
        let tableData = Object.assign({},{ cmp_data: this.props.cmp_data },{ cmp_id: this.props.cmp_id },{ cmp_name: this.props.cmp_name },{ cmp_type: this.props.cmp_type },{ sub_cmps: this.props.sub_cmps },{ biz_data: this.props.biz_data });
        let buttonData = Object.assign({}, btnItem, {
            cmpContext,
            data,
            tableData,
            afterAction,
            queryUrl,
            pageType
        });

        if (buttonData.cmp_id) {
            if (this[buttonData.cmp_id]) {
                return false;
            }
            // 设置再次响应的1s延迟，当连续点击时不会重复发请求等
            this[buttonData.cmp_id] = setTimeout(() => {
                this[buttonData.cmp_id] = null;
            }, 1000);
        }
        this.props.actions.btnStartFn(buttonData);
        this.rowButtonListClear();
    }

    rowButtonListClear() {
        if(this.props.cmp_data.isSyncRowHandler) {
            this.setState({ isShowChoose: false });
            return;
        }
        this.props.actions.rowButtonListClear(this.props.cmp_id);
    }

    hasLoadMoreBtn(currentDataList) {
        if(this.props.disableLoadMore || this.props.rowsLimit) {
            return false;
        }
        if(this.props.cmp_data.paging) {
            let maxPage = Math.ceil(this.props.cmp_data.paging.total / this.props.cmp_data.paging.capacity);
            maxPage = maxPage > 0 ? maxPage - 1 : 0;
            return this.loadedPageRange.max < maxPage;
        }
        if(this.props.cmp_data.paging && this.props.cmp_data.paging.total != currentDataList.length && this.props.cmp_data.paging.total != 0) {
            return true;
        }
    }

    showMoreList(event) {
        event.preventDefault();
        if(this.props.loadMore) {
            this.props.loadMore();
        }else{
            this.fetchTableViewData(this.loadedPageRange.max + 1, this.searchData, this.sortData, 'isLoadMore');
        }
    }

    setEmptyHeight(expandHeight) {
        const tableContainerHeight = this.refs.dataTableContainer && this.refs.dataTableContainer.offsetHeight;
        const expandRegionHeight = expandHeight || 0;
        this.setState({ emptyHeight: tableContainerHeight - expandRegionHeight });
    }

    renderTableTitle() {
         return  this.props.showTableTitle ? <TableTitle tableTitle={this.props.title || this.props.cmp_data.title}
                                                         loadmore={this.hasMore}
                                                         touchTapMore={this.touchTapMore} /> : null;
    }

    renderTable() {
        let datalist = this.genBasicComponentNeededDataList();
        let rowButtonList = [];
        const isShowMore = this.hasLoadMoreBtn(datalist);
        if(!this.checkTableHasRecord()) {
            return (<EmptyIcon containerHeight={this.state.emptyHeight}
                              num={this.props.num}
                    />);

        }
        if(this.props.cmp_data.isSyncRowHandler && this.props.rows) {
            this.props.rows.forEach((item,index) => {
                if(item['sub_cmps'] && item['sub_cmps']['buttonList'] && item['sub_cmps']['buttonList']['sub_cmps']) {
                    rowButtonList.push(item['sub_cmps']['buttonList']['sub_cmps']);
                }
            });
        }

        const bottomHeight = this.props.hasBottomButton() ? buttonListHeight : 0;
        const { translation } = this;
        const listBottom = this.props.rowsLimit ? null :
                                (isShowMore ? <div ref="showMoreArea" className='show-more-button' onTouchTap={this.showMoreList}>
                                                    <span className="load-more"></span>
                                                    <span className="show-more-text">{translation.loading}</span>
                                                </div>
                                :  <div className='show-no-more' style={!this.shouldShowNoMore ? { display: 'none' } : {}}>{translation.noMore}</div>);

        const tableListStyle = !this.props.rowsLimit && isShowMore ?  { minHeight: window.innerHeight - bottomHeight - headerHeight } : null;

        const { partId = '' } = helper.getQueryObject();
        const listContent = (<TableList style={tableListStyle}
                                        tableType={this.props.tableType}
                                        key={this.props.cmp_id + this.props.cmp_data.length}
                                        rowTemplate={this.props.cmp_data.rowTemplate}
                                        tableColumn={this.props.cmp_data.tableColumn}
                                        originRows={this.props.biz_data}
                                        standardFormatedRows={datalist}
                                        originColumns={this.props.sub_cmps}
                                        rowsLimit={this.props.rowsLimit}
                                        selectIds={this.props.selectIds}
                                        showChecked={(this.props.showChecked && this.props.cmp_data.hasCheckColumn) || false}
                                        globleChecked={this.props.globleChecked}
                                        hasAvatars={this.props.cmp_data.isAvatars}
                                        hasRowHandler={this.props.cmp_data.hasRowHandler && !this.props.isNoShowRowButton}
                                        isSyncRowHandler={this.props.cmp_data.isSyncRowHandler}
                                        rowButtonList={rowButtonList}
                                        rowButtonItemTouchTap={this.rowButtonItemTouchHandler}
                                        isAndroid={this.props.isAndroid}
                                        onTouchTap={this.tableItemClick}
                                        onRowTouchTap={this.onRowTouchTap}
                                        containerHeight={this.state.emptyHeight}
                                        num={this.props.num}
                                        actions={this.props.actions}
                                        setClickPos={this.setClickPos}
                                        partId={partId || this.props.partId}
                            />);

        const ptrOptions = {
                onRefresh: this.loadPrevPage.bind(this),
                isRefreshing: this.props.isLoadPrev || this.state.fakeLoading
        };

        const canPullToRefresh = this.props.allowPTR && this.loadedPageRange.first > 0 && !this.props.rowsLimit;

        return (
            <div ref="DataTableList" className={classNames({ 'table-list': isShowMore })} >
               {canPullToRefresh ? <PullToRefresh {...ptrOptions}> {listContent} {listBottom} </PullToRefresh> : null}
               {!canPullToRefresh ? listContent : null}
               {!canPullToRefresh ? listBottom : null}
            </div>
        );
    }

    renderTableButton() {
        const buttonAttr = { ...this.props,
            reloadTable: this.reloadTable,
            rowButtonListClear: this.rowButtonListClear,
            rowButtonTouchTap: this.rowButtonTouchTap,
            isShowChoose: this.state.isShowChoose,
            index: this.index
        };
        return <ButtonChoose {...buttonAttr} translation={this.translation} />;
    }

    render() {
        const { translation } = this;
        const onLoading = !this.props.cmp_id || !this.props.sub_cmps || this.props.isFetching || this.pageIsRetry || (this.needLoadTableDataAfterMount() && !this.isTableMounted);
        const { rowsLimit, showMoreBottom, accLoading } = this.props;
        this.hasMore = (rowsLimit && (this.props.cmp_data.paging.total > rowsLimit)) ? true : false;
        return (
            <div ref="dataTableContainer" className={classNames('datatable_container',{ 'hasShowMoreBottom': showMoreBottom && this.hasMore })} style={BSGlobal.application === 'ELearning' ? { background: '#fff' } : null}>
                {onLoading ? null : this.renderTableTitle()}
                {onLoading ? (accLoading ? <AccLoading /> : <ListLoad />) :
                    (<div ref="datatable">
                        {this.props.expandRegion ? <ComponentHolder ref="expandRegion" setEmptyHeight={this.setEmptyHeight.bind(this)} componentName={this.props.expandRegion.view_path} {...this.props} searchData={this.searchData} sortData={this.sortData} /> : null}
                        {this.renderTable()}
                    </div>)
                }
                {showMoreBottom && this.hasMore && BSGlobal.application !== 'ELearning' ? <div className='bottom-showmore' onTouchTap={this.touchTapMore}>{translation.viewMore}</div> : null}
                {this.renderTableButton()}
                {window.env.platform.bsAppIOS ? <div className="ele-trans" ref="elementForTrans" /> : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTable.js